export default __webpack_public_path__ + "static/media/contributeFundOthers.1f09dbcc.png";